module.exports = __webpack_public_path__ + "static/media/wallet-link.85e26e96.svg";